import { SystemUserWorkspace } from '../system-user/system-user-workspace';

export class User {
  public userId: string;
  public lastPasswordReset: Date;
  public lastLogin: Date;
  public loginsCount: string;
  public createdAt: Date;
  public picture: string;
  public firstName: string;
  public lastName: string;
  public nickName: string;
  public fullName: string;
  public email: string;
  public roles: Role[];
  public workspaces: SystemUserWorkspace[];

  public get displayName(): string {
    let _displayName = 'Unknown';
    if (this.firstName && this.lastName) {
      _displayName = `${this.firstName} ${this.lastName}`;
    } else if (this.nickName) {
      _displayName = this.nickName;
    } else {
      _displayName = this.fullName;
    }

    return _displayName;
  }

  public get role(): Role {
    if (this.roles.includes(Role.Staff)) return Role.Staff;
    if (this.roles.includes(Role.Owner)) return Role.Owner;
    if (this.roles.includes(Role.Admin)) return Role.Admin;
    if (this.roles.includes(Role.User)) return Role.User;
    if (this.roles.includes(Role.Manager)) return Role.Manager;
    if (this.roles.includes(Role.Editor)) return Role.Editor;
  }

  public get displayRole(): string {
    if (this.role == Role.Staff) return 'Lineup Staff';
    if (this.role == Role.Owner) return 'Owner';
    if (this.role == Role.Admin) return 'Admin';
    if (this.role == Role.User) return 'View-only';
    if (this.role == Role.Manager) return 'Manager';
    if (this.role == Role.Editor) return 'Editor';
  }
  constructor(data: User) {
    Object.assign(this, data);
  }
}

export enum Role {
  Staff = 'Staff',
  Owner = 'Owner',
  Admin = 'Admin',
  User = 'User',
  Manager = 'Manager',
  Editor = 'Editor',
}
